import React from 'react';

export const ICApartment: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 800 800"
        >
            <path d="M733.332 33.332h-400C314.926 33.332 300 48.258 300 66.668v166.664H66.668c-18.41 0-33.336 14.926-33.336 33.336v466.664c0 18.41 14.926 33.336 33.336 33.336h666.664c18.41 0 33.336-14.926 33.336-33.336V66.668c0-18.41-14.926-33.336-33.336-33.336zM100 300h200v400H100zm600 400H366.668V100H700zm-66.668-466.668h-200v-66.664h200zm0 133.336h-200V300h200zm0 133.332h-200v-66.668h200zm0 133.332h-200v-66.664h200zm-466.664-300h66.664V400h-66.664zm0 133.336h66.664v66.664h-66.664zm0 133.332h66.664v66.668h-66.664zm0 0"></path>
        </svg>
    );
};
